import { render, staticRenderFns } from "./RightMenu_Ap.vue?vue&type=template&id=7a275b37&scoped=true"
import script from "./RightMenu_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenu_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenu_Ap.vue?vue&type=style&index=0&id=7a275b37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a275b37",
  null
  
)

export default component.exports